import React from 'react';
import { View, Text } from 'react-native-web';
import { withRouter } from 'react-router-dom';

import NavBar from "../../components/NavBar";
import NewsAccessCard from "../news/cards/NewsAccessCard";
import JourneySelectionCard from "../journeyStack/cards/JourneySelectionCard";
import {Spacing} from "../../components";


class HomeScreen extends React.Component {

	render() {
		return (
			<NavBar title={'Home'}>

				<View style={{ width: 400, }}>
					<JourneySelectionCard />

					<Spacing height={22} />

					<NewsAccessCard />
				</View>

			</NavBar>
		)
	}
}

export default withRouter(HomeScreen);
